import { Column } from 'devextreme-react/data-grid';
import { useSearchOrders } from "../api/search-orders";
import { OrderSearchGridProps } from '../types/OrderSearchGridProps';
import { OrderSearchParams } from '../types/OrderSearchParams';
import { Link, useLocation } from 'react-router-dom';
import { LoadPagePanel, SyncDataGrid } from '../../../../components';
import { KindOfOrder } from '../../../../types/enums';

export default function OrderSearchGrid(props: OrderSearchGridProps) {

    let params = { searchField: props.searchField } as OrderSearchParams;
    params[props.searchField as keyof OrderSearchParams] = props.searchText;

    const orders = useSearchOrders({ ...params, dateFrom: props.dateFrom, dateTo: props.dateTo });

    const location = useLocation();
    const returnUrl = encodeURIComponent(location.pathname + location.search);

    function getOrderUrl(order: any) {
        let url;

        if (order.kindOfOrderID === KindOfOrder.WorkOrder) {
            url = `/dealer/work-order/${order.orderID}?returnUrl=${returnUrl}`;
        }
        else
            if (order.kindOfOrderID === KindOfOrder.Estimate) {
                url = `/dealer/estimate/${order.orderID}?returnUrl=${returnUrl}`;
            }
            else {
                url = `/dealer/retail-order/${order.orderID}?returnUrl=${returnUrl}`;
            }

        return url;
    }

    return (
        <>
            <SyncDataGrid
                stateStorageKey='dealer-order-search-grid-v2'
                className={'dx-card wide-card'}
                dataSource={orders.data}
                keyExpr={['orderNumber']}
                height="68vh"
            >
                <Column
                    dataField={'orderNumber'}
                    caption={'Order #'}
                    dataType="string"
                    cellRender={(cell: any) => {
                        return <Link to={getOrderUrl(cell.data)}>
                            {cell.data.orderNumber}
                        </Link>;
                    }}
                />
                <Column
                    dataField={'projectNumber'}
                    caption={'Project #'}
                    dataType="string"
                />
                <Column
                    dataField={'date'}
                    caption={'Customer Order Date'}
                    dataType="date"
                />
                <Column
                    dataField={'createdOn'}
                    caption={'Creation Date'}
                    dataType="datetime"
                />
                <Column
                    dataField={'orderStatus'}
                    caption={'Status'}
                    dataType="string"
                />
                <Column
                    dataField={'orderType'}
                    caption={'Order Type'}
                    dataType="string"
                />
                <Column
                    dataField={'dealerNumber'}
                    caption={'Store #'}
                    dataType="string"
                />
                <Column
                    dataField={'customerName'}
                    caption={'Customer Name'}
                    dataType="string"
                />
                <Column
                    dataField={'customerAddress'}
                    caption={'Address'}
                    dataType="string"
                />
                <Column
                    dataField={'customerPhone'}
                    caption={'Customer Phone #'}
                    dataType="string"
                />
                <Column
                    dataField={'customerCityZip'}
                    caption={'City/State,Zip'}
                    dataType="string"
                />
                <Column
                    dataField={'cfiCompanyName'}
                    caption={'CFI'}
                    dataType="string"
                />
                <Column
                    dataField={'colorGroup'}
                    caption={'Color Group'}
                    dataType="string"
                />
                <Column
                    dataField={'colorName'}
                    caption={'Color Name'}
                    dataType="string"
                />
            </SyncDataGrid>

            <LoadPagePanel visible={orders.isLoading} />
        </>
    )
} 
